import { render, staticRenderFns } from "./FormTemplateFilter.vue?vue&type=template&id=27d37e0c&scoped=true&"
import script from "./FormTemplateFilter.vue?vue&type=script&lang=js&"
export * from "./FormTemplateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d37e0c",
  null
  
)

export default component.exports